import { render, staticRenderFns } from "./formPemenuhanKewajiban.vue?vue&type=template&id=63901e91&scoped=true&"
import script from "./formPemenuhanKewajiban.vue?vue&type=script&lang=js&"
export * from "./formPemenuhanKewajiban.vue?vue&type=script&lang=js&"
import style0 from "./formPemenuhanKewajiban.vue?vue&type=style&index=0&id=63901e91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63901e91",
  null
  
)

export default component.exports